import {
  CircleCheck,
  Info,
  LoaderCircle,
  OctagonX,
  TriangleAlert,
} from "lucide-react"
import { useTheme } from "@/client/components/theme-provider"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheck className="h-4 w-4" />,
        info: <Info className="h-4 w-4" />,
        warning: <TriangleAlert className="h-4 w-4" />,
        error: <OctagonX className="h-4 w-4" />,
        loading: <LoaderCircle className="h-4 w-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast: [
            "group toast",
            "group-[.toaster]:bg-background",
            "group-[.toaster]:text-foreground",
            "group-[.toaster]:border-border",
            "group-[.toaster]:shadow-lg",
          ].join(" "),
          description: "group-[.toast]:text-muted-foreground",
          actionButton: [
            "group-[.toast]:bg-primary",
            "group-[.toast]:text-primary-foreground",
          ].join(" "),
          cancelButton: [
            "group-[.toast]:bg-muted",
            "group-[.toast]:text-muted-foreground",
          ].join(" "),
          success: [
            "group-[.toaster]:!bg-emerald-600",
            "group-[.toaster]:!text-white",
            "group-[.toaster]:!border-emerald-500",
          ].join(" "),
          info: [
            "group-[.toaster]:border-0",
            // Light mode
            "group-[.toaster]:bg-gray-800",
            "group-[.toaster]:text-gray-50",
            // Dark mode
            "dark:group-[.toaster]:bg-gray-50",
            "dark:group-[.toaster]:text-gray-800",
          ].join(" "),
        },
      }}
      richColors
      {...props}
    />
  )
}

export { Toaster }
